import { actionsPreprocessor } from '@/utils/redux';

const actionNames = [
  'LOG_IN',
  'LOG_IN_SUCCESS',
  'LOG_IN_ERROR',

  'SIGN_UP',
  'SIGN_UP_SUCCESS',
  'SIGN_UP_ERROR',

  'SIGN_OUT',
  'SIGN_OUT_SUCCESS',
  'SIGN_OUT_ERROR',

  'CHECK_TOKEN',
  'CHECK_TOKEN_SUCCESS',
  'CHECK_TOKEN_FAILED',
  'CANCEL_CHECK_TOKEN',

  'UPDATE_USER',
  'UPDATE_USER_SUCCESS',
  'UPDATE_USER_FAILED',

  'UPDATE_ORGANIZATION',
  'UPDATE_ORGANIZATION_SUCCESS',
  'UPDATE_ORGANIZATION_FAILED',

  'SEND_EMAIL_RESET',
  'SEND_EMAIL_RESET_SUCCESS',
  'SEND_EMAIL_RESET_FAILED',

  'RESET_PASSWORD',
  'RESET_PASSWORD_SUCCESS',
  'RESET_PASSWORD_FAILED',

  'FETCH_ORGANIZATIONS',
  'FETCH_ORGANIZATIONS_SUCCESS',
  'FETCH_ORGANIZATIONS_FAILED',

  'AVATAR_UPLOAD',
  'REMOVE_AVATAR',

  'RESET_ERRORS',
  'SET_TERMS_POLICY_PAYLOAD',

  'ACCEPT_TERMS_AND_POLICY',
  'ACCEPT_TERMS_AND_POLICY_SUCCESS',
  'ACCEPT_TERMS_AND_POLICY_FAILED',

  'SAVE_SUPPORT_INFO',
  'SAVE_SUPPORT_INFO_SUCCESS',
  'SAVE_SUPPORT_INFO_FAILED',
];

const { actions, actionTypes } = actionsPreprocessor('auth', actionNames);

export default actions;
export { actionTypes };
